import React from 'react';
import './CreateRoleHeader.css';
import ButtonRolesAction from '../ButtonRolesAction/ButtonRolesAction';
const CreateRoleHeader = ({
  handleApplyRole,
  handleCreateRoleClose,
  typeAction,
}) => {
  const saveRole = () => {
    handleApplyRole();
  };
  return (
    <div className='create-role-header'>
      <h1 className='create-role-header__title'>{`${
        typeAction === 'edit' ? 'Изменить' : 'Создать'
      } роль`}</h1>
      <ButtonRolesAction
        onClick={saveRole}
        children={'+ СОХРАНИТЬ'}
        className={'create-role-header_save'}
      />
      <button onClick={handleCreateRoleClose} className='profile__close-btn' />
    </div>
  );
};

export default CreateRoleHeader;
